import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from '../api/signupApi'
import * as st from './SignupSt'
import * as sst from '../share/Style'

const USER_REGEX = /^[a-zA-Z][a-zA-Z0-9_]{6,18}$/
const PW_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/
const REGISTER_URL = '/api/user/signup'

function Signups() {

    let navigate = useNavigate()

    const userRef = useRef()
    const errRef = useRef()

    const [nickname, setNickname] = useState('')
    const [nicknameFocus, setNicknameFocus] = useState(false)

    const [userId, setUserId] = useState('')
    const [validuserId, setValiduserId] = useState(false)
    const [userIdFocus, setUserIdFocus] = useState(false)

    const [password, setPassword] = useState('')
    const [validPw, setValidPw] = useState(false)
    const [pwFocus, setPwFocus] = useState(false)

    const [matchPw, setMatchPw] = useState('')
    const [validMatch, setValidMatch] = useState(false)
    const [matchFocus, setMatchFocus] = useState(false)

    const [success, setSuccess] = useState(false)

    useEffect(() => {
        userRef.current.focus()
    }, [])

    useEffect(() => {
        const result = USER_REGEX.test(userId)
        console.log(result)
        console.log(userId)
        setValiduserId(result)
    }, [userId])

    useEffect(() => {
        const result = PW_REGEX.test(password)
        console.log(result)
        console.log(password)
        setValidPw(result)
        const match = password === matchPw
        setValidMatch(match)
    }, [password, matchPw])

    const handleSubmit = async (e) => {
        e.preventDefault()
        // if button enabled with JS hack
        const v1 = USER_REGEX.test(userId)
        const v2 = PW_REGEX.test(password)
        if (!v1 || !v2) {
            alert('아이디와 비밀번호를 조건에 맞게 입력해주세요!')
            return
        }
        try {
            const response = await axios.post(REGISTER_URL,
                JSON.stringify({ nickname, userId, password:password }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            )
            console.log(response.data)
            console.log(response.accessToken)
            console.log(JSON.stringify(response))
            setSuccess(true)
            alert('회원이 되신 것을 환영합니다!')
            navigate('/login')
            // clear input fields
        } catch (err) {
            if (!err?.response) {
                alert('서버의 응답이 없습니다')
            } else if (err.response?.status === 409) {
                alert('중복된 아이디입니다')
            } else {
                alert('회원가입에 실패했습니다')
            }
            errRef.current.focus()
        }
    }

    return (
        <st.SignupBox>
            
            <h1 className='SignBoxH1'>회원가입 🎉</h1>
            <st.SignInputBox>
                <st.SignLabel htmlFor='nickname'>닉네임
                    <span className={nickname == '' ? "valid" : "hide"}>🚨</span>
                    <span className={nickname.length >= 1 ? "valid" : "hide"}>✔</span>
                </st.SignLabel>
                <st.SignInput id='nickname'
                    ref={userRef}
                    value={nickname}
                    onChange={(e) => setNickname(e.target.value)}
                    required
                    onFocus={() => setNicknameFocus(true)}
                    onBlur={() => setNicknameFocus(false)} />
            </st.SignInputBox>

            <st.SignInputBox>
                <st.SignLabel htmlFor='userId'>아이디
                    <span className={validuserId ? "valid" : "hide"}>✔</span>
                    <span className={validuserId || !userId ? "hide" : "invalid"}>🚨</span>
                </st.SignLabel>
                <sst.Row>
                    <st.SignInput id='userId'
                        value={userId}
                        autoComplete='off'
                        onChange={(e) => setUserId(e.target.value)}
                        required
                        aria-invalid={validuserId ? "false" : "true"}
                        aria-describedby='uidnote'
                        onFocus={() => setUserIdFocus(true)}
                        onBlur={() => setUserIdFocus(false)} />
                </sst.Row>
                <st.SingCheckMsg id="uidnote" className={userIdFocus && userId && !validuserId ? "instructions" : "offscreen"}>
                    아이디는 6~18자의 소문자, 숫자입니다
                </st.SingCheckMsg>
            </st.SignInputBox>

            <st.SignInputBox>
                <st.SignLabel htmlFor='pw'>비밀번호
                    <span className={validPw ? "valid" : "hide"}>✔</span>
                    <span className={validPw || !password ? "hide" : "invalid"}>🚨</span>
                </st.SignLabel>
                <st.SignInput type="password" id='pw'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} required
                    aria-invalid={validPw ? "false" : "true"}
                    aria-describedby='pwnote'
                    onFocus={() => setPwFocus(true)}
                    onBlur={() => setPwFocus(false)} />
                <st.SingCheckMsg id="pwnote" className={pwFocus && !validPw ? "instructions" : "offscreen"}>
                    비밀번호는 대소문자, 숫자, 특수문자 포함 8~20자입니다
                </st.SingCheckMsg>
            </st.SignInputBox>

            <st.SignInputBox>
                <st.SignLabel htmlFor='putPwCheck'>비밀번호 확인
                    <span className={validMatch ? "valid" : "hide"}>✔</span>
                    <span className={validMatch || !matchPw ? "hide" : "invalid"}>🚨</span>
                </st.SignLabel>
                <st.SignInput type="password" id='putPwCheck'
                    value={matchPw}
                    onChange={(e) => setMatchPw(e.target.value)}
                    required
                    aria-invalid={validMatch ? "false" : "true"}
                    aria-describedby='confirmnote'
                    onFocus={() => setMatchFocus(true)}
                    onBlur={() => setMatchFocus(false)} />
                <st.SingCheckMsg id="confirmnote" className={matchFocus && !validMatch ? "instructions" : "offscreen"}>
                    비밀번호를 한번 더 입력해주세요
                </st.SingCheckMsg>
            </st.SignInputBox>

            <sst.Button fn="sign" onClick={handleSubmit}>회원가입 완료</sst.Button>
        </st.SignupBox>
    )
}

export default Signups